
export class CancelReceiptDetail {
  id: number;
  receiptCancellationId: number;
  economicActId: number;
}
